var map = {
	"./BAWS_AxeBasic1_2.png": "e112",
	"./BAWS_AxeBasic2_1.png": "2860",
	"./BAWS_AxeEvolving3_3_2.png": "5d19",
	"./BAWS_Dagger1_3_5.png": "2cd2",
	"./BAWS_Dagger4_1_3.png": "188c",
	"./BAWS_Hammer1_1_3.png": "df5e",
	"./BAWS_Polearm2_2_2.png": "a3d6",
	"./BAWS_Scythe1_3_2.png": "2d6c",
	"./BAWS_Shield2_1_2.png": "1df1",
	"./BAWS_Shield3_1_1.png": "9268",
	"./BAWS_Staff2_2_6.png": "05d4",
	"./BAWS_Staff4_1_1.png": "eca0",
	"./BAWS_Staff5_1_1.png": "f788",
	"./BAWS_Sword1_1_3.png": "632d",
	"./BAWS_Sword2_3_3.png": "edee",
	"./BAWS_Sword3_1_3.png": "28ae",
	"./BAWS_Sword5_3_2.png": "e9c9",
	"./Barbarian_Axe_OneHanded.png": "b00d",
	"./BlinkArt_Axe1H_Basic.png": "5061",
	"./BlinkArt_Axe1H_Epic.png": "a322",
	"./BlinkArt_Axe1H_Medium.png": "f8c0",
	"./BlinkArt_Axe2H_Basic.png": "14487",
	"./BlinkArt_Axe2H_Epic.png": "64cf",
	"./BlinkArt_Axe2H_Medium.png": "74c9",
	"./BlinkArt_Bow_Basic.png": "8747",
	"./BlinkArt_Bow_Epic.png": "e30e",
	"./BlinkArt_Bow_Medium.png": "212e",
	"./BlinkArt_Mace1H_Basic.png": "642b",
	"./BlinkArt_Mace1H_Epic.png": "7145",
	"./BlinkArt_Mace1H_Medium.png": "a035",
	"./BlinkArt_Mace2H_Epic.png": "bbad",
	"./BlinkArt_Mace2H_Medium.png": "9d9c",
	"./BlinkArt_Shield_Basic.png": "42b6",
	"./BlinkArt_Shield_Epic.png": "4b7e",
	"./BlinkArt_Shield_Medium.png": "7161",
	"./BlinkArt_Spear1H_Basic.png": "1559",
	"./BlinkArt_Spear1H_Epic.png": "73d4",
	"./BlinkArt_Spear1H_Epic2.png": "c0e0",
	"./BlinkArt_Spear1H_Medium.png": "fac5",
	"./BlinkArt_Spear2H_Epic.png": "8aa45",
	"./BlinkArt_Spear2H_Medium.png": "4539",
	"./BlinkArt_Staff_Basic.png": "cddf",
	"./BlinkArt_Staff_Epic.png": "17ae",
	"./BlinkArt_Staff_Medium.png": "0e04",
	"./BlinkArt_Sword10_Bone.png": "9b77",
	"./BlinkArt_Sword10_Dark.png": "6921",
	"./BlinkArt_Sword11_Blood.png": "4654",
	"./BlinkArt_Sword11_Dark.png": "1ec3",
	"./BlinkArt_Sword12_Green.png": "038f",
	"./BlinkArt_Sword12_Purple.png": "e3e2",
	"./BlinkArt_Sword12_Red.png": "173e",
	"./BlinkArt_Sword13_Blue.png": "f572",
	"./BlinkArt_Sword13_Cyan.png": "0972",
	"./BlinkArt_Sword13_Green.png": "e837",
	"./BlinkArt_Sword13_Orange.png": "8720",
	"./BlinkArt_Sword14_Blue.png": "fc39",
	"./BlinkArt_Sword14_Red.png": "0f31",
	"./BlinkArt_Sword14_Yellow.png": "1f52",
	"./BlinkArt_Sword15_Earth.png": "ac31",
	"./BlinkArt_Sword15_Frost.png": "666e",
	"./BlinkArt_Sword15_Iron.png": "6756",
	"./BlinkArt_Sword15_Lava.png": "dc17",
	"./BlinkArt_Sword1_Bronze.png": "84af",
	"./BlinkArt_Sword1_Gold.png": "a8b7",
	"./BlinkArt_Sword1_Silver.png": "6235",
	"./BlinkArt_Sword2_Green.png": "03a2",
	"./BlinkArt_Sword2_Red.png": "9383",
	"./BlinkArt_Sword2_Yellow.png": "814c",
	"./BlinkArt_Sword3_Blue.png": "71451",
	"./BlinkArt_Sword3_Green.png": "3279",
	"./BlinkArt_Sword3_Red.png": "1d4b",
	"./BlinkArt_Sword4_Blue.png": "bee1",
	"./BlinkArt_Sword4_Red.png": "9f6a",
	"./BlinkArt_Sword4_Yellow.png": "49fa",
	"./BlinkArt_Sword5_Blue.png": "4abd",
	"./BlinkArt_Sword5_Gold.png": "eb5d",
	"./BlinkArt_Sword5_Red.png": "4bc5",
	"./BlinkArt_Sword5_Yellow.png": "5ca5",
	"./BlinkArt_Sword6_Blue.png": "90d6",
	"./BlinkArt_Sword6_Red.png": "c355",
	"./BlinkArt_Sword6_Yellow.png": "5b04",
	"./BlinkArt_Sword7_Blue.png": "b0d5",
	"./BlinkArt_Sword7_Green.png": "30c3",
	"./BlinkArt_Sword7_Red.png": "3df2",
	"./BlinkArt_Sword8_Corrupted.png": "00fb",
	"./BlinkArt_Sword8_Gold.png": "82e9",
	"./BlinkArt_Sword8_White.png": "9057",
	"./BlinkArt_Sword9_Blue.png": "ed88",
	"./BlinkArt_Sword9_Green.png": "4ff1",
	"./BlinkArt_Sword9_Purple.png": "e6ab",
	"./BlinkArt_Sword9_Red.png": "72c5",
	"./BlinkArt_Sword9_White.png": "de9c",
	"./BlinkArt_Wand_Basic.png": "e7ca",
	"./BlinkArt_Wand_Epic.png": "d6f4",
	"./BlinkArt_Wand_Medium.png": "550a",
	"./CRT_Bow 001.png": "480a",
	"./CRT_Bow 002.png": "89df",
	"./CRT_P2_Sword-001.png": "229a",
	"./CRT_P2_Sword-002.png": "1ced",
	"./CRT_P2_Sword-003.png": "478b",
	"./CRT_P2_Sword-004.png": "5bc9",
	"./CRT_P2_Sword-005.png": "f71c",
	"./CRT_P2_Sword-006.png": "238a",
	"./CRT_Spear-001.png": "7d99",
	"./CRT_Spear-002.png": "4f12",
	"./CRT_Spear-003.png": "4e9e",
	"./CRT_Spear-004.png": "b219",
	"./CRT_Spear-005.png": "8105",
	"./CRT_Spear-006.png": "1f3e",
	"./CRT_Sword-001.png": "01e3",
	"./CRT_Sword-002.png": "fe4c",
	"./CRT_Sword-003.png": "09fb",
	"./CRT_Sword-004.png": "7744",
	"./CRT_Sword-005.png": "1777",
	"./CRT_Sword-006.png": "07a9",
	"./CRT_WF_Weapon-Aex.png": "045d",
	"./CRT_WF_Weapon-Stick.png": "041e",
	"./CRT_WF_Weapon-Sword-1.png": "047b",
	"./CRT_WF_Weapon-Sword-2.png": "8d39",
	"./CRT_WF_Weapon-Sword-3.png": "9dca",
	"./CRT_WF_Weapon-Wand.png": "e53b",
	"./CRT_Weapon-Fan-01.png": "1f63",
	"./CRT_Weapon-Fan-02.png": "03f0",
	"./CRT_Weapon-Sword-01.png": "07a4",
	"./CRT_Weapon-Sword-02.png": "d1c3",
	"./CRT_Weapon-Sword-03.png": "2d23",
	"./CRT_Weapon-Sword-04.png": "c08d",
	"./CRT_Weapon-Sword-05.png": "0de9",
	"./CRT_Weapon-Wand-01.png": "192e",
	"./CRT_Weapon-Wand-02.png": "75e0",
	"./CRT_Weapon-Wand-03.png": "7d5f",
	"./CTWP__Arrow.png": "ada9",
	"./CTWP__Bow.png": "0c81",
	"./CTWP__Dagger.png": "7d44",
	"./CTWP__Espadon.png": "d22d4",
	"./CTWP__Quiver.png": "d745",
	"./CTWP__Shield_01.png": "08e0",
	"./CTWP__Shield_02.png": "78ee",
	"./CTWP__Shield_03.png": "b702",
	"./CTWP__Staff_01.png": "1760",
	"./CTWP__Staff_02.png": "9bd5",
	"./CTWP__Staff_03.png": "5a23",
	"./CTWP__Staff_04.png": "6ddb6",
	"./CTWP__Staff_05.png": "2be0",
	"./CTWP__Staff_06.png": "e7fe",
	"./CTWP__Sword_01.png": "4fe4",
	"./CTWP__Sword_02.png": "7bb7",
	"./CTWP__Sword_03.png": "4e35",
	"./CTWP__Sword_04.png": "baa4",
	"./CattleyaoneHandedSword_02.png": "3e51",
	"./CattleyaoneHandedSword_03.png": "3975",
	"./CattleyaoneHandedSword_04.png": "3829",
	"./CattleyaoneHandedSword_05.png": "b7ee",
	"./CattleyaoneHandedSword_06.png": "532f",
	"./CattleyaoneHandedSword_07.png": "39a4",
	"./DFW_Arrow.png": "bbe3e",
	"./DFW_Axe.png": "51c1",
	"./DFW_Bow.png": "3289",
	"./DFW_DarkSword.png": "f6f6",
	"./DFW_DemonStaff.png": "8b30",
	"./DFW_GoldSword.png": "d500",
	"./DFW_NatureStaff.png": "1d3f",
	"./DFW_Shield.png": "c5aa",
	"./DFW_SpikedClub.png": "5bcb",
	"./DFW_StoneSword.png": "8b60",
	"./DK_DKShield.png": "03f8",
	"./DK_DKSword.png": "4b04",
	"./DK_DragonKnife_correctAngle.png": "a42c",
	"./DS_DemonicSword.png": "cf67",
	"./Dagger_dagger.png": "f186",
	"./DemonDagger_dagger.png": "716d",
	"./Elven_Arrow_02.png": "b8ba",
	"./Elven_Axe_01.png": "907f",
	"./Elven_Bow_01.png": "2c47",
	"./Elven_Hammer_01.png": "eb87",
	"./Elven_Shield_01.png": "aa7d",
	"./Elven_Spear_01.png": "9a00",
	"./Elven_Staff_01.png": "22a8",
	"./Elven_Sword_01.png": "d09f",
	"./FAS_FantasyAxe_Unity.png": "761e",
	"./FAS_FantasyShield.png": "383f",
	"./FHWP_axe.png": "60385",
	"./FHWP_dark_sword.png": "59af",
	"./FHWP_hammer.png": "9f23",
	"./FHWP_mace.png": "0a4c",
	"./FHWP_skull_axe.png": "3838",
	"./FSAB_StylizedFantasyAssassinBlade v1.png": "79cc",
	"./FSAB_StylizedFantasyAssassinBlade v2.png": "e271",
	"./FSAB_StylizedFantasyAssassinBlade v3.png": "1fe3",
	"./FSBS_big sword v1.png": "9bd51",
	"./FSBS_big sword v2.png": "0fa01",
	"./FSBS_big sword v3.png": "33af",
	"./FS_Fantasy sword.png": "6a47",
	"./FS_FireSword.png": "d62d",
	"./FTHS__FantasyHammer.png": "b31a",
	"./FTHS__FantasyHammer_2.png": "431f",
	"./FTHS__FantasyShield.png": "5f00",
	"./FTHS__FantasyShield_2.png": "60d5",
	"./FTS_sword_sample.png": "0ca4",
	"./FW_AngelBlade.png": "e4c3",
	"./FW_Angelsword.png": "f480",
	"./FW_Moon&Star Staff.png": "7379",
	"./FW_MoonAndStarBlade.png": "e624",
	"./FW_MoonAndStarSword.png": "0dc4",
	"./FW_Plantblade.png": "b008",
	"./FW_Plantsword.png": "2137",
	"./FW_Wingblade.png": "0ba3",
	"./FW_Wingsword.png": "2eb3",
	"./Flur_01.png": "1f65",
	"./G_Art_Claw_R_1_1_1.png": "7c0b",
	"./G_Art_Claw_R_1_1_2.png": "8d03",
	"./G_Art_Claw_R_1_1_3.png": "d1e1",
	"./G_Art_Claw_R_1_1_4.png": "48cc",
	"./G_Art_Claw_R_1_1_5.png": "ed3c",
	"./G_Art_Claw_R_1_2_1.png": "cd53",
	"./G_Art_Claw_R_1_2_2.png": "4da7",
	"./G_Art_Claw_R_1_2_3.png": "57dd",
	"./G_Art_Claw_R_1_2_4.png": "dd06",
	"./G_Art_Claw_R_1_2_5.png": "faf4",
	"./G_Art_Claw_R_1_3_1.png": "d464",
	"./G_Art_Claw_R_1_3_2.png": "8be3",
	"./G_Art_Claw_R_1_3_3.png": "b4b2",
	"./G_Art_Claw_R_1_3_4.png": "244b",
	"./G_Art_Claw_R_1_3_5.png": "a185",
	"./G_Art_Claw_R_2_1_1.png": "e3c2",
	"./G_Art_Claw_R_2_1_2.png": "2107",
	"./G_Art_Claw_R_2_1_3.png": "f6ec",
	"./G_Art_Claw_R_2_1_4.png": "f062",
	"./G_Art_Claw_R_2_1_5.png": "0efb",
	"./G_Art_Claw_R_2_2_1.png": "56e9",
	"./G_Art_Claw_R_2_2_2.png": "cd61",
	"./G_Art_Claw_R_2_2_3.png": "e2e3",
	"./G_Art_Claw_R_2_2_4.png": "aedf",
	"./G_Art_Claw_R_2_2_5.png": "dc33",
	"./G_Art_Claw_R_2_3_1.png": "92fd",
	"./G_Art_Claw_R_2_3_2.png": "c876",
	"./G_Art_Claw_R_2_3_3.png": "7144",
	"./G_Art_Claw_R_2_3_4.png": "ef47",
	"./G_Art_Claw_R_2_3_5.png": "ccaa",
	"./G_Art_Claw_R_3_1_1.png": "0922",
	"./G_Art_Claw_R_3_1_2.png": "2628",
	"./G_Art_Claw_R_3_1_3.png": "28a3e",
	"./G_Art_Claw_R_3_1_4.png": "e83c",
	"./G_Art_Claw_R_3_1_5.png": "75d2",
	"./G_Art_Claw_R_3_2_1.png": "218d",
	"./G_Art_Claw_R_3_2_2.png": "c612",
	"./G_Art_Claw_R_3_2_3.png": "6008",
	"./G_Art_Claw_R_3_2_4.png": "78a0",
	"./G_Art_Claw_R_3_2_5.png": "ccf9",
	"./G_Art_Claw_R_3_3_1.png": "878d",
	"./G_Art_Claw_R_3_3_2.png": "6dd5",
	"./G_Art_Claw_R_3_3_3.png": "8e63",
	"./G_Art_Claw_R_3_3_4.png": "1de3",
	"./G_Art_Claw_R_3_3_5.png": "6a0c",
	"./G_Sword_MaterialRdy_Greatsword.png": "03c2",
	"./HPFM_axe_mobile.png": "8614",
	"./HPFM_hammer_mobile.png": "b0c4",
	"./HPFM_machete_mobile.png": "159f",
	"./HVS_HeavySword.png": "37ba",
	"./Heavy_Full_Metal_Sword.png": "0630",
	"./Hovl_MagicSword_Iron.png": "ba06f",
	"./LCRG_Swords_01.png": "fa2c",
	"./LCRG_Swords_02.png": "5707",
	"./LCRG_Swords_03.png": "c8bf",
	"./LCRG_Swords_04.png": "c2cc",
	"./LCRG_Swords_05.png": "37d4",
	"./LCRG_Swords_06.png": "f486",
	"./LPN_Sword_Cyber_Greenway.png": "26aa",
	"./LPN_Sword_Cyber_Magma.png": "72b3",
	"./LPN_Sword_Cyber_Plasma.png": "19c7",
	"./LPW_Dagger.png": "8ea3",
	"./LPW_Shield.png": "3b4d",
	"./LPW_Sword.png": "b6a3",
	"./MS_Spear.png": "7423",
	"./MS_WeaponSword000.png": "f76f",
	"./MS_WeaponSword001.png": "ce2e",
	"./MS_WeaponSword002.png": "5755",
	"./MS_WeaponSword003.png": "1e3d",
	"./MS_WeaponSword004.png": "5a67",
	"./MS_WeaponSword005.png": "9c60",
	"./MS_WeaponSword006.png": "4b6f",
	"./MS_WeaponSword007.png": "e3bf",
	"./MS_WeaponSword008.png": "0bc0",
	"./MS_WeaponSword009.png": "ade8",
	"./MS_WeaponSword010.png": "2963",
	"./Medieval_Sword_EuropeanBroad.png": "04a0",
	"./Medieval_Sword_Falchion.png": "00fb9",
	"./Medieval_Sword_Katana.png": "95c1",
	"./Medieval_Sword_Rapier.png": "a063",
	"./Medieval_Sword_Scimitar.png": "d42d",
	"./Medieval_Sword_Viking.png": "9770",
	"./MoonSword 1.png": "82ad",
	"./MoonSword 1b.png": "10f5",
	"./MoonSword 2.png": "f63e",
	"./MoonSword 2b.png": "acd2",
	"./MoonSword 3.png": "340d",
	"./MoonSword 3b.png": "e707",
	"./MoonSword 4.png": "fd63",
	"./MoonSword 4b.png": "799b",
	"./MoonSword 5.png": "3300",
	"./MoonSword 5b.png": "e289",
	"./MoonSword 6.png": "b9fb",
	"./MoonSword 6b.png": "cb6d",
	"./Newbie_Axe_01_Classic.png": "43af",
	"./Newbie_Axe_02_Classic.png": "852c",
	"./Newbie_Axe_02_Mage.png": "67bb",
	"./Newbie_Axe_03_Classic.png": "fa27",
	"./Newbie_Axe_04_Classic.png": "f93a",
	"./Newbie_Axe_04_Mage.png": "ad84",
	"./Newbie_Bow_01_Classic.png": "d4d0",
	"./Newbie_Bow_01_Mage.png": "58f3",
	"./Newbie_Bow_01_Ranger.png": "590c",
	"./Newbie_Bow_01_Warrior.png": "f7ac",
	"./Newbie_Bow_02_Classic.png": "1770",
	"./Newbie_Bow_02_Mage.png": "28f6",
	"./Newbie_Bow_02_Ranger.png": "c65d",
	"./Newbie_Bow_02_Warrior.png": "f9eb",
	"./Newbie_Bow_03_Classic.png": "6145",
	"./Newbie_Bow_03_Mage.png": "f353",
	"./Newbie_Dagger_01_Classic.png": "527c",
	"./Newbie_Dagger_01_Mage.png": "a246",
	"./Newbie_Dagger_01_Ranger.png": "71e3",
	"./Newbie_Dagger_01_Warrior.png": "7fd5",
	"./Newbie_Dagger_02_Classic.png": "562c",
	"./Newbie_Dagger_02_Mage.png": "efb5",
	"./Newbie_Dagger_02_Ranger.png": "d314",
	"./Newbie_Dagger_02_Warrior.png": "7185",
	"./Newbie_Dagger_03_Classic.png": "e48f",
	"./Newbie_Dagger_03_Mage.png": "d160",
	"./Newbie_Dagger_03_Ranger.png": "6df6",
	"./Newbie_Dagger_03_Warrior.png": "fd66",
	"./Newbie_Shield_01_Classic.png": "6316",
	"./Newbie_Shield_01_Mage.png": "83b9e",
	"./Newbie_Shield_01_Ranger.png": "d3d7",
	"./Newbie_Shield_01_Warrior.png": "7ec1",
	"./Newbie_Shield_02_Classic.png": "3d4d",
	"./Newbie_Shield_02_Mage.png": "78b1",
	"./Newbie_Shield_02_Ranger.png": "ee08",
	"./Newbie_Shield_02_Warrior.png": "7e02",
	"./Newbie_Shield_03_Classic.png": "bd59",
	"./Newbie_Shield_03_Mage.png": "9c3a",
	"./Newbie_Shield_03_Ranger.png": "a460",
	"./Newbie_Staff_01.png": "3172",
	"./Newbie_Staff_01_Classic.png": "ae95",
	"./Newbie_Staff_02_Classic.png": "5b2c",
	"./Newbie_Staff_02_Mage.png": "b083",
	"./Newbie_Staff_03_Classic.png": "a796",
	"./Newbie_Staff_03_Mage.png": "7624",
	"./Newbie_Staff_04_Classic.png": "acfc",
	"./Newbie_Sword_01_Classic.png": "7b19",
	"./Newbie_Sword_01_Warrior.png": "7ffb",
	"./Newbie_Sword_02_Classic.png": "8277",
	"./Newbie_Sword_02_Ranger.png": "f0c5",
	"./Newbie_Sword_02_Warrior.png": "c983",
	"./Newbie_Sword_03_Classic.png": "cd1e",
	"./Newbie_Sword_03_Warrior.png": "3da3",
	"./Newbie_Sword_04_Classic.png": "5af8",
	"./Newbie_Sword_04_Warrior.png": "3049",
	"./OAS_HandPaintedRunicSword_Blue_Pref.png": "2941",
	"./OAS_HandPaintedRunicSword_Green_Pref.png": "e5cb",
	"./OAS_HandPaintedRunicSword_Steel_Pref.png": "9578",
	"./P150T_weapon_1.png": "8594",
	"./P150T_weapon_10.png": "dd51",
	"./P150T_weapon_100.png": "1dec",
	"./P150T_weapon_101.png": "2b74",
	"./P150T_weapon_102.png": "a813",
	"./P150T_weapon_103.png": "fca9",
	"./P150T_weapon_104.png": "8fb3",
	"./P150T_weapon_105.png": "2948",
	"./P150T_weapon_107.png": "6a2f",
	"./P150T_weapon_108.png": "91cb",
	"./P150T_weapon_109.png": "1108",
	"./P150T_weapon_11.png": "a2f0",
	"./P150T_weapon_110.png": "bbbe",
	"./P150T_weapon_111.png": "a7ae",
	"./P150T_weapon_112.png": "0484",
	"./P150T_weapon_113.png": "ca9b",
	"./P150T_weapon_114.png": "f346",
	"./P150T_weapon_115.png": "818a",
	"./P150T_weapon_116.png": "6b80",
	"./P150T_weapon_117.png": "6308",
	"./P150T_weapon_118.png": "15b4",
	"./P150T_weapon_119.png": "341ba",
	"./P150T_weapon_12.png": "ad4c",
	"./P150T_weapon_120.png": "8d9b",
	"./P150T_weapon_121.png": "e866",
	"./P150T_weapon_122.png": "23a9",
	"./P150T_weapon_123.png": "5544",
	"./P150T_weapon_124.png": "48bb",
	"./P150T_weapon_125.png": "157e",
	"./P150T_weapon_126.png": "f191",
	"./P150T_weapon_127.png": "4a71",
	"./P150T_weapon_128.png": "2262",
	"./P150T_weapon_129.png": "e89e",
	"./P150T_weapon_13.png": "6d6b",
	"./P150T_weapon_130.png": "9cfe",
	"./P150T_weapon_131.png": "bb2d",
	"./P150T_weapon_132.png": "290a",
	"./P150T_weapon_133.png": "2d87",
	"./P150T_weapon_134.png": "2f624",
	"./P150T_weapon_135.png": "d7b8",
	"./P150T_weapon_136.png": "ac9d",
	"./P150T_weapon_137.png": "89e1",
	"./P150T_weapon_138.png": "dd40",
	"./P150T_weapon_139.png": "b3d7",
	"./P150T_weapon_14.png": "b9a0",
	"./P150T_weapon_140.png": "9f74",
	"./P150T_weapon_141.png": "1c56",
	"./P150T_weapon_142.png": "8de7",
	"./P150T_weapon_143.png": "3b73",
	"./P150T_weapon_144.png": "a1f4",
	"./P150T_weapon_145.png": "95d3",
	"./P150T_weapon_146.png": "d335",
	"./P150T_weapon_147.png": "3970",
	"./P150T_weapon_148.png": "b141",
	"./P150T_weapon_149.png": "edb8",
	"./P150T_weapon_15.png": "1215",
	"./P150T_weapon_150.png": "0489",
	"./P150T_weapon_151.png": "6583",
	"./P150T_weapon_152.png": "14a26",
	"./P150T_weapon_153.png": "81b1",
	"./P150T_weapon_154.png": "3a80",
	"./P150T_weapon_155.png": "2827",
	"./P150T_weapon_156.png": "a08a",
	"./P150T_weapon_157.png": "bdd5",
	"./P150T_weapon_158.png": "0a23",
	"./P150T_weapon_159.png": "8468",
	"./P150T_weapon_16.png": "8e50",
	"./P150T_weapon_160.png": "afe7",
	"./P150T_weapon_17.png": "2cf2",
	"./P150T_weapon_18.png": "d98a",
	"./P150T_weapon_19.png": "1568",
	"./P150T_weapon_20.png": "362b",
	"./P150T_weapon_21.png": "5e784",
	"./P150T_weapon_22.png": "5c33",
	"./P150T_weapon_23.png": "b8e3",
	"./P150T_weapon_24.png": "ae57",
	"./P150T_weapon_25.png": "2c88",
	"./P150T_weapon_26.png": "cf0d",
	"./P150T_weapon_27.png": "b7e0",
	"./P150T_weapon_28.png": "a162",
	"./P150T_weapon_29.png": "c70f",
	"./P150T_weapon_3.png": "a2a9",
	"./P150T_weapon_30.png": "6299",
	"./P150T_weapon_31.png": "569f",
	"./P150T_weapon_32.png": "c080",
	"./P150T_weapon_34.png": "9158",
	"./P150T_weapon_35.png": "2e1e",
	"./P150T_weapon_36.png": "e174",
	"./P150T_weapon_37.png": "ddbc",
	"./P150T_weapon_38.png": "212f",
	"./P150T_weapon_39.png": "e777",
	"./P150T_weapon_4.png": "205f",
	"./P150T_weapon_40.png": "fa6b",
	"./P150T_weapon_41.png": "e6ce",
	"./P150T_weapon_42.png": "52a7a",
	"./P150T_weapon_43.png": "19d2",
	"./P150T_weapon_44.png": "c2ac",
	"./P150T_weapon_45.png": "4f5b",
	"./P150T_weapon_46.png": "d71f",
	"./P150T_weapon_47.png": "3241",
	"./P150T_weapon_48.png": "f556",
	"./P150T_weapon_49.png": "7104",
	"./P150T_weapon_50.png": "828b",
	"./P150T_weapon_51.png": "7207",
	"./P150T_weapon_53.png": "0df4",
	"./P150T_weapon_55.png": "f2a6",
	"./P150T_weapon_56.png": "9070",
	"./P150T_weapon_57.png": "7fb3b",
	"./P150T_weapon_58.png": "a829",
	"./P150T_weapon_59.png": "1ebb",
	"./P150T_weapon_6.png": "bb2a",
	"./P150T_weapon_60.png": "1861",
	"./P150T_weapon_61.png": "7ed0",
	"./P150T_weapon_62.png": "aca8",
	"./P150T_weapon_63.png": "14ce",
	"./P150T_weapon_64.png": "ef2f",
	"./P150T_weapon_65.png": "a333",
	"./P150T_weapon_69.png": "5aeb",
	"./P150T_weapon_7.png": "b890",
	"./P150T_weapon_70.png": "597d",
	"./P150T_weapon_71.png": "6d14",
	"./P150T_weapon_72.png": "85be",
	"./P150T_weapon_73.png": "0b7c",
	"./P150T_weapon_74.png": "28f3",
	"./P150T_weapon_75.png": "a5e16",
	"./P150T_weapon_76.png": "cf4b",
	"./P150T_weapon_77.png": "4560",
	"./P150T_weapon_78.png": "25ed",
	"./P150T_weapon_79.png": "4b31",
	"./P150T_weapon_8.png": "964a",
	"./P150T_weapon_80.png": "6f0b",
	"./P150T_weapon_81.png": "73b3",
	"./P150T_weapon_82.png": "8ccf",
	"./P150T_weapon_83.png": "ef7f",
	"./P150T_weapon_88.png": "40b5",
	"./P150T_weapon_89.png": "59f0",
	"./P150T_weapon_9.png": "3a78",
	"./P150T_weapon_90.png": "204d",
	"./P150T_weapon_91.png": "b0f0",
	"./P150T_weapon_92.png": "7806",
	"./P150T_weapon_93.png": "76b6",
	"./P150T_weapon_94.png": "0462",
	"./P150T_weapon_95.png": "f4c7",
	"./P150T_weapon_96.png": "59b3",
	"./P150T_weapon_97.png": "75f8",
	"./P150T_weapon_98.png": "b171",
	"./P150T_weapon_99.png": "71fb",
	"./P300T_Toon_Weapon_1002.png": "dbfd",
	"./P300T_Toon_Weapon_1003.png": "f98f",
	"./P300T_Toon_Weapon_1004.png": "d239",
	"./P300T_Toon_Weapon_1008.png": "39dd",
	"./P300T_Toon_Weapon_1012.png": "8ad3",
	"./P300T_Toon_Weapon_1013.png": "f916",
	"./P300T_Toon_Weapon_1019.png": "c570",
	"./P300T_Toon_Weapon_1020.png": "43d5",
	"./P300T_Toon_Weapon_1023.png": "d751",
	"./P300T_Toon_Weapon_1024.png": "ba3c",
	"./P300T_Toon_Weapon_1029.png": "ab34",
	"./P300T_Toon_Weapon_1030.png": "8c5b",
	"./P300T_Toon_Weapon_1031.png": "0675",
	"./P300T_Toon_Weapon_1036.png": "bc21",
	"./P300T_Toon_Weapon_1037.png": "83aa",
	"./P300T_Toon_Weapon_1040.png": "f233",
	"./P300T_Toon_Weapon_1041.png": "785d",
	"./P300T_Toon_Weapon_1042.png": "54975",
	"./P300T_Toon_Weapon_1043.png": "965a",
	"./P300T_Toon_Weapon_1046.png": "daa4",
	"./P300T_Toon_Weapon_1048.png": "b328",
	"./P300T_Toon_Weapon_1049.png": "8aba",
	"./P300T_Toon_Weapon_1057.png": "0f83",
	"./P300T_Toon_Weapon_1058.png": "0abd",
	"./P300T_Toon_Weapon_1065.png": "31b0",
	"./P300T_Toon_Weapon_1066.png": "b833",
	"./P300T_Toon_Weapon_1073.png": "0407",
	"./P300T_Toon_Weapon_1078.png": "c318",
	"./P300T_Toon_Weapon_1079.png": "50d0",
	"./P300T_Toon_Weapon_1080.png": "4ddf",
	"./P300T_Toon_Weapon_1087.png": "ef5c",
	"./P300T_Toon_Weapon_1088.png": "1e34",
	"./P300T_Toon_Weapon_1094.png": "4292",
	"./P300T_Toon_Weapon_1095.png": "f008",
	"./P300T_Toon_Weapon_1098.png": "2e0f",
	"./P300T_Toon_Weapon_1099.png": "5c11",
	"./P300T_Toon_Weapon_1101.png": "510f",
	"./P300T_Toon_Weapon_1105.png": "e427",
	"./P300T_Toon_Weapon_1107.png": "637e",
	"./P300T_Toon_Weapon_1114.png": "320f",
	"./P300T_Toon_Weapon_1115.png": "9d93",
	"./P300T_Toon_Weapon_1116.png": "b510f",
	"./P300T_Toon_Weapon_1121.png": "2f2b",
	"./P300T_Toon_Weapon_1122.png": "0328",
	"./P300T_Toon_Weapon_1127.png": "1f19",
	"./P300T_Toon_Weapon_1130.png": "9cc9",
	"./P300T_Toon_Weapon_1135.png": "c18a",
	"./P300T_Toon_Weapon_1138.png": "3a27",
	"./P300T_Toon_Weapon_1141.png": "f8fb",
	"./P300T_Toon_Weapon_1142.png": "78c0",
	"./P300T_Toon_Weapon_1150.png": "e6d3",
	"./P300T_Toon_Weapon_1151.png": "0ef7",
	"./P300T_Toon_Weapon_1154.png": "d880",
	"./P300T_Toon_Weapon_1156.png": "e6ff",
	"./P300T_Toon_Weapon_1165.png": "d2de",
	"./P300T_Toon_Weapon_1174.png": "1b9c",
	"./P300T_Toon_Weapon_1178.png": "47bb",
	"./P300T_Toon_Weapon_1181.png": "f1ca",
	"./P300T_Toon_Weapon_1187.png": "19d20",
	"./P300T_Toon_Weapon_1188.png": "50fd",
	"./P300T_Toon_Weapon_1193.png": "26c3",
	"./P300T_Toon_Weapon_1196.png": "75ef",
	"./P300T_Toon_Weapon_1201.png": "1f5d",
	"./P300T_Toon_Weapon_1202.png": "df8b",
	"./P300T_Toon_Weapon_1207.png": "ac59",
	"./P300T_Toon_Weapon_1214.png": "ac29",
	"./P300T_Toon_Weapon_1215.png": "8a44",
	"./P300T_Toon_Weapon_1217.png": "a7cf",
	"./P300T_Toon_Weapon_1218.png": "6f84",
	"./P300T_Toon_Weapon_1221.png": "d5a1",
	"./P300T_Toon_Weapon_1222.png": "c2ef",
	"./P300T_Toon_Weapon_1223.png": "4d1a",
	"./P300T_Toon_Weapon_1224.png": "03ff",
	"./P300T_Toon_Weapon_1226.png": "408b",
	"./P300T_Toon_Weapon_1230.png": "ad43",
	"./P300T_Toon_Weapon_1231.png": "4c25",
	"./P300T_Toon_Weapon_1240.png": "4744",
	"./P300T_Toon_Weapon_1241.png": "4fbb",
	"./P300T_Toon_Weapon_1242.png": "d457",
	"./P300T_Toon_Weapon_1243.png": "29ac",
	"./P300T_Toon_Weapon_1246.png": "5f8d",
	"./P300T_Toon_Weapon_1247.png": "90ff",
	"./P300T_Toon_Weapon_1248.png": "2ff8",
	"./P300T_Toon_Weapon_1249.png": "2713",
	"./P300T_Toon_Weapon_1252.png": "ca02",
	"./P300T_Toon_Weapon_1253.png": "d58f",
	"./P300T_Toon_Weapon_1266.png": "6c58",
	"./P300T_Toon_Weapon_1268.png": "4fe7",
	"./P300T_Toon_Weapon_1271.png": "ada0",
	"./P300T_Toon_Weapon_1272.png": "88dc",
	"./P300T_Toon_Weapon_1280.png": "b733",
	"./P300T_Toon_Weapon_1284.png": "815d",
	"./P300T_Toon_Weapon_1286.png": "2899",
	"./P300T_Toon_Weapon_1288.png": "d5bd",
	"./P300T_Toon_Weapon_1289.png": "5301",
	"./P300T_Toon_Weapon_1290.png": "48f5",
	"./P300T_Toon_Weapon_1292.png": "e611",
	"./P300T_Toon_Weapon_1294.png": "0f71",
	"./P300T_Toon_Weapon_1296.png": "b4de",
	"./P300T_Toon_Weapon_1297.png": "18d1a",
	"./P300T_Toon_Weapon_1298.png": "abe0",
	"./P300T_Toon_Weapon_1302.png": "84dd",
	"./PP_Sword_0018.png": "b9ac",
	"./PP_Sword_0036.png": "9e50",
	"./PP_Sword_0080.png": "0cae",
	"./PP_Sword_0177.png": "4ed5",
	"./PP_Sword_0222.png": "744c",
	"./PP_Sword_0363.png": "fe7d",
	"./PP_Sword_1039.png": "4b1a",
	"./RB_Falchion.png": "0b4f",
	"./RB_Gladius.png": "e7b7",
	"./RB_Greatsword.png": "d4dd",
	"./RB_Rapier.png": "2fc7",
	"./RP_Pugio01.png": "762f",
	"./RS_Rune Sword.png": "37af7",
	"./SAS_BastardSword.png": "c679",
	"./SAS_BlackLeatherRoundShield.png": "4fd8",
	"./SAS_BlueKnightlyShield.png": "f539",
	"./SAS_BlueWhiteNomadShield.png": "1ce0",
	"./SAS_Broadsword.png": "53c2",
	"./SAS_Claymore.png": "1992",
	"./SAS_LeatherNomadShield.png": "d0ea",
	"./SAS_Longsword Ver2.png": "eafb",
	"./SAS_Longsword.png": "9a3a",
	"./SAS_MetalHeaterShield.png": "d65f",
	"./SAS_MetalKiteShield.png": "95f5",
	"./SAS_PaintedKiteShield.png": "538b",
	"./SAS_Polished Steel Buckler.png": "17e9",
	"./SAS_RedPaintedRoundShield.png": "016e",
	"./SAS_RedWhiteNomadShield.png": "4ef8",
	"./SAS_RoughGreenNomadShield.png": "de2f",
	"./SAS_Standard Sword.png": "7758",
	"./SAS_Sword Ver2.png": "f693",
	"./SAS_WoodenKiteShield.png": "ca12",
	"./SD_Steel_Dagger_512.png": "05dd",
	"./SGW_Free_sword.png": "cf10",
	"./SH2D_300001.png": "a69e",
	"./SH2D_300002.png": "db04",
	"./SH2D_300003.png": "2227",
	"./SH2D_300004.png": "ccfd",
	"./SH2D_300005.png": "d71d",
	"./SH2D_300006.png": "8786",
	"./SH2D_300007.png": "7764",
	"./SH2D_300008.png": "f426",
	"./SH2D_300009.png": "0ec4",
	"./SH2D_30001.png": "c093",
	"./SH2D_30002.png": "f61e",
	"./SH2D_30003.png": "0604",
	"./SH2D_30004.png": "3f61",
	"./SH2D_30005.png": "7974",
	"./SH2D_30006.png": "d423",
	"./SH2D_30007.png": "4b1d",
	"./SH2D_30008.png": "870b",
	"./SH2D_30009.png": "6c24",
	"./SOWTA_Bright_1k.png": "6990",
	"./SOWTA_Deep_1k.png": "d3f6",
	"./SOWTA_Original_1k.png": "9d9cd",
	"./SPC_Sword1 Clean OneMaterial.png": "dc77",
	"./SPC_Sword2 Clean OneMaterial.png": "85cd",
	"./SPC_Sword3 Clean OneMaterial.png": "d77a",
	"./SPC_Sword4 Clean OneMaterial.png": "3adb",
	"./SPC_Sword5 Clean OneMaterial.png": "c4c5",
	"./SSWS_Big_sword.png": "fc91",
	"./SSWS_Black_Sword.png": "918a",
	"./SSWS_Bronze_sword.png": "bb36",
	"./SSWS_DARK_Sword.png": "80aa",
	"./SSWS_Glass_sword.png": "1e60",
	"./SSWS_Knight_sword.png": "7b08",
	"./SSWS_MODERN_sword.png": "a682",
	"./SSWS_Modern_Sword_Canonical.png": "22f3",
	"./SSWS_Pearl_sword.png": "7727",
	"./SSWS_Steel_sword.png": "07ef",
	"./STHander_Sword Two-Hander Base.png": "108c",
	"./STHander_Sword Two-Hander Blue.png": "ca13",
	"./STHander_Sword Two-Hander Purple.png": "4bd4",
	"./STHander_Sword Two-Hander Yellow.png": "65b7",
	"./SWP_Axe_1H_02 (1).png": "1856",
	"./SWP_Axe_1H_02 (2).png": "780a",
	"./SWP_Axe_1H_02.png": "ee55",
	"./SWP_Axe_1H_03 (1).png": "fc73",
	"./SWP_Axe_1H_03 (2).png": "047e",
	"./SWP_Axe_1H_03.png": "80c8",
	"./SWP_Axe_1H_04 (1).png": "ec9b",
	"./SWP_Axe_1H_05 (1).png": "37b3",
	"./SWP_Axe_1H_05 (2).png": "5371",
	"./SWP_Axe_1H_05.png": "5f08",
	"./SWP_Axe_1H_06 (1).png": "ec8b",
	"./SWP_Axe_1H_06 (2).png": "48a2",
	"./SWP_Axe_1H_06.png": "c11b",
	"./SWP_Axe_2H_01 (1).png": "fdb3",
	"./SWP_Axe_2H_01 (2).png": "4cbd",
	"./SWP_Axe_2H_01.png": "17de",
	"./SWP_Axe_2H_02 (1).png": "890a",
	"./SWP_Axe_2H_02 (2).png": "0ce4",
	"./SWP_Axe_2H_02.png": "0426",
	"./SWP_Axe_2H_03 (1).png": "c062",
	"./SWP_Axe_2H_03 (2).png": "be0d",
	"./SWP_Axe_2H_03.png": "b5aa",
	"./SWP_Axe_2H_04 (1).png": "7783",
	"./SWP_Axe_2H_04 (2).png": "6f78",
	"./SWP_Axe_2H_04.png": "569c",
	"./SWP_Axe_2H_05 (1).png": "ce41",
	"./SWP_Axe_2H_05 (2).png": "8109",
	"./SWP_Axe_2H_05.png": "e548",
	"./SWP_Axe_2H_06 (1).png": "455d",
	"./SWP_Axe_2H_06 (2).png": "47ead",
	"./SWP_Axe_2H_06.png": "2455",
	"./SWP_Hammer_1H_01 (1).png": "9244",
	"./SWP_Hammer_1H_01 (2).png": "56ca",
	"./SWP_Hammer_1H_01.png": "dcf4",
	"./SWP_Hammer_2H_01 (2).png": "9e58",
	"./SWP_Hammer_2H_01.png": "8193",
	"./SWP_Hammer_2H_02 (1).png": "abf2",
	"./SWP_Hammer_2H_02 (2).png": "23a4",
	"./SWP_Hammer_2H_02.png": "d1c8",
	"./SWP_Hammer_2H_03 (1).png": "a7e5",
	"./SWP_Hammer_2H_03 (2).png": "eac9",
	"./SWP_Hammer_2H_03.png": "c34b",
	"./SWP_Shield_01 (1).png": "54f8",
	"./SWP_Shield_01 (2).png": "6dda",
	"./SWP_Shield_01.png": "142e",
	"./SWP_Shield_02 (1).png": "99a5",
	"./SWP_Shield_02 (2).png": "e601",
	"./SWP_Shield_02.png": "a7f3",
	"./SWP_Shield_03 (1).png": "527a",
	"./SWP_Shield_03 (2).png": "2ff7",
	"./SWP_Shield_03.png": "0d10",
	"./SWP_Shield_04 (1).png": "4d4d",
	"./SWP_Shield_04 (2).png": "afcd",
	"./SWP_Shield_04.png": "6189",
	"./SWP_Shield_05 (1).png": "e133b",
	"./SWP_Shield_05 (2).png": "8261",
	"./SWP_Shield_05.png": "05b9",
	"./SWP_Shield_06 (1).png": "d129",
	"./SWP_Shield_06 (2).png": "194a",
	"./SWP_Shield_06.png": "c00d",
	"./SWP_Shield_07 (1).png": "46ce",
	"./SWP_Shield_07 (2).png": "bf6b",
	"./SWP_Shield_07.png": "6455",
	"./SWP_Shield_08 (1).png": "b969",
	"./SWP_Shield_08 (2).png": "29b2",
	"./SWP_Shield_08.png": "cd91",
	"./SWP_Shield_09 (1).png": "c817",
	"./SWP_Shield_09 (2).png": "db37",
	"./SWP_Shield_09.png": "009d",
	"./SWP_Staff_2H_01 (1).png": "7e03",
	"./SWP_Staff_2H_01.png": "4d18",
	"./SWP_Staff_2H_02 (1).png": "90fd",
	"./SWP_Staff_2H_02 (2).png": "901f",
	"./SWP_Staff_2H_02.png": "3d69",
	"./SWP_Staff_2H_03 (1).png": "80c3",
	"./SWP_Staff_2H_03 (2).png": "a6a0",
	"./SWP_Staff_2H_05 (1).png": "1f5a",
	"./SWP_Staff_2H_05 (2).png": "80e8",
	"./SWP_Staff_2H_05.png": "0565",
	"./SWP_Staff_2H_06 (1).png": "cbf9",
	"./SWP_Staff_2H_06 (2).png": "9a63",
	"./SWP_Staff_2H_06.png": "1025",
	"./SWP_Sword_1H_01 (1).png": "4c95",
	"./SWP_Sword_1H_01 (2).png": "ec2b",
	"./SWP_Sword_1H_01.png": "1dca",
	"./SWP_Sword_1H_02 (1).png": "7b1e",
	"./SWP_Sword_1H_02 (2).png": "34d5",
	"./SWP_Sword_1H_02.png": "49fd",
	"./SWP_Sword_1H_03 (1).png": "2fd4",
	"./SWP_Sword_1H_03 (2).png": "f29a",
	"./SWP_Sword_1H_03.png": "9473",
	"./SWP_Sword_1H_04 (1).png": "b4be",
	"./SWP_Sword_1H_04 (2).png": "56c5",
	"./SWP_Sword_1H_04.png": "b77a",
	"./SWP_Sword_1H_05 (1).png": "d90b",
	"./SWP_Sword_1H_05.png": "054d",
	"./SWP_Sword_2H_01 (1).png": "df8d",
	"./SWP_Sword_2H_01 (2).png": "3216",
	"./SWP_Sword_2H_01.png": "c1d1",
	"./SWP_Sword_2H_02 (1).png": "a5e9",
	"./SWP_Sword_2H_02 (2).png": "4cbf",
	"./SWP_Sword_2H_02.png": "31c4",
	"./SWP_Sword_2H_03 (1).png": "98f8",
	"./SWP_Sword_2H_03 (2).png": "a668",
	"./SWP_Sword_2H_03.png": "ab9d",
	"./SWP_Sword_2H_04 (1).png": "fa8d",
	"./SWP_Sword_2H_04 (2).png": "dc64",
	"./SWP_Sword_2H_04.png": "b551",
	"./SWP_Sword_2H_05 (1).png": "cfae",
	"./SWP_Sword_2H_05 (2).png": "86c3",
	"./SWP_Sword_2H_05.png": "e0a8",
	"./SWP_Sword_2H_06 (1).png": "930d",
	"./SWP_Sword_2H_06.png": "ce4c",
	"./SW_Stylized sword_2.png": "8f20",
	"./Stylized Sword-Basic.png": "4535",
	"./Stylized Sword-Bloody.png": "e7e1",
	"./Stylized Sword-Gold.png": "ea8a",
	"./Stylized Sword-Haze.png": "75c6",
	"./Stylized Sword-Ice.png": "675e",
	"./Stylized_knife.png": "6e52",
	"./Superb_sword_01.png": "0f47",
	"./Superb_sword_02.png": "3e2a",
	"./Superb_sword_03.png": "09da",
	"./Superb_sword_04.png": "e13d",
	"./Superb_sword_05.png": "cae6",
	"./Superb_sword_06.png": "fd1d",
	"./Superb_sword_07.png": "1d96",
	"./Superb_sword_08.png": "1438",
	"./Superb_sword_09.png": "2cdf",
	"./Superb_sword_10.png": "e78a",
	"./Superb_sword_11.png": "57a3",
	"./Superb_sword_12.png": "0792",
	"./Superb_sword_13.png": "b9fe",
	"./Superb_sword_14.png": "f0b8",
	"./Superb_sword_15.png": "63a8",
	"./Superb_sword_16.png": "1678",
	"./Superb_sword_17.png": "c26f",
	"./Superb_sword_18.png": "d0d3",
	"./Sword_Stormbringer_00_FREE.png": "f136",
	"./TDE_Bow.png": "bd3c",
	"./TDE_Grenade.png": "3985",
	"./TDE_Hammer.png": "68b3",
	"./TDE_MiniPortal.png": "a843",
	"./TDE_Missile_01.png": "9ba4",
	"./TDE_SciFiPoleComp.png": "5055",
	"./TDE_Sword.png": "4470",
	"./TFS_FantasySword.png": "66e2",
	"./Ventuar_Metal Battleaxe.png": "c7ad",
	"./Ventuar_Metal Broadsword.png": "9cb3",
	"./Ventuar_Metal Halberd.png": "45bf",
	"./Ventuar_Metal Mace.png": "09a3",
	"./Ventuar_Metal Sword.png": "0cba",
	"./Ventuar_Spiked Halberd.png": "f92d",
	"./Ventuar_Spiked Hammer.png": "73d2",
	"./Ventuar_Wooden Shield.png": "253a",
	"./WP1_CrystalSword.png": "ea85",
	"./WP1_FrostAxe.png": "9564",
	"./WP1_FurnaceSword.png": "c197",
	"./WP1_IronSword.png": "1987",
	"./WP_Snake_Greatsword.png": "0953",
	"./WTMS_sword1.png": "3e40",
	"./WTMS_sword2.png": "bf20",
	"./WTMS_sword3.png": "51f6",
	"./WTMS_sword4.png": "dbc7",
	"./Weapon_01.png": "a3dc",
	"./Weapon_02.png": "d516",
	"./Weapon_03.png": "8695",
	"./Weapon_04.png": "a297",
	"./Weapon_05.png": "a963",
	"./Weapon_06.png": "caf0",
	"./Weapon_07.png": "3864",
	"./Weapon_08.png": "2665",
	"./Weapon_09.png": "9823",
	"./Weapon_10.png": "eedb",
	"./Weapon_100.png": "e1a2",
	"./Weapon_101.png": "738b",
	"./Weapon_102.png": "d00d",
	"./Weapon_103.png": "250d",
	"./Weapon_104.png": "aa12",
	"./Weapon_105.png": "606b",
	"./Weapon_106.png": "7f98",
	"./Weapon_107.png": "1866",
	"./Weapon_109.png": "ab7b",
	"./Weapon_11.png": "4dbf",
	"./Weapon_110.png": "0820",
	"./Weapon_112.png": "c9d0",
	"./Weapon_113.png": "cfe3",
	"./Weapon_114.png": "73df",
	"./Weapon_115.png": "6db7",
	"./Weapon_116.png": "1855",
	"./Weapon_117.png": "3cab",
	"./Weapon_118.png": "c1a6",
	"./Weapon_119.png": "111c",
	"./Weapon_12.png": "ce94",
	"./Weapon_120.png": "ee88",
	"./Weapon_121.png": "1b82",
	"./Weapon_122.png": "40b0",
	"./Weapon_123.png": "0e26",
	"./Weapon_124.png": "3a00",
	"./Weapon_125.png": "f2dc",
	"./Weapon_126.png": "9dff",
	"./Weapon_127.png": "c2ec",
	"./Weapon_128.png": "0694",
	"./Weapon_129.png": "582f",
	"./Weapon_13.png": "1985",
	"./Weapon_130.png": "cf2a",
	"./Weapon_131.png": "1e7a",
	"./Weapon_132.png": "66e0",
	"./Weapon_133.png": "1ef4",
	"./Weapon_134.png": "65f7",
	"./Weapon_135.png": "0d3f",
	"./Weapon_136.png": "bf57",
	"./Weapon_138.png": "bc16",
	"./Weapon_139.png": "169a",
	"./Weapon_14.png": "9731",
	"./Weapon_140.png": "9a57",
	"./Weapon_141.png": "4618",
	"./Weapon_142.png": "4981",
	"./Weapon_143.png": "dd6b",
	"./Weapon_144.png": "c122",
	"./Weapon_145.png": "9db7",
	"./Weapon_146.png": "8836",
	"./Weapon_147.png": "69eb",
	"./Weapon_148.png": "aa75",
	"./Weapon_149.png": "fc21",
	"./Weapon_15.png": "8cfb",
	"./Weapon_150.png": "d393",
	"./Weapon_151.png": "7a0f",
	"./Weapon_152.png": "d821",
	"./Weapon_153.png": "661c",
	"./Weapon_155.png": "4ee8",
	"./Weapon_156.png": "2c60",
	"./Weapon_157.png": "bd3b",
	"./Weapon_158.png": "6d73",
	"./Weapon_159.png": "44ca",
	"./Weapon_160.png": "9692",
	"./Weapon_161.png": "1c4c",
	"./Weapon_162.png": "6f8d",
	"./Weapon_163.png": "6a95",
	"./Weapon_164.png": "b9b1",
	"./Weapon_165.png": "7cf7",
	"./Weapon_166.png": "c920",
	"./Weapon_168.png": "e003",
	"./Weapon_169.png": "4236",
	"./Weapon_17.png": "af39e",
	"./Weapon_170.png": "c818",
	"./Weapon_171.png": "da63",
	"./Weapon_172.png": "4e41",
	"./Weapon_173.png": "b69f",
	"./Weapon_174.png": "f00b",
	"./Weapon_175.png": "f601",
	"./Weapon_176.png": "3962",
	"./Weapon_177.png": "e8f4",
	"./Weapon_178.png": "29b1",
	"./Weapon_179.png": "6efa",
	"./Weapon_18.png": "d9b9",
	"./Weapon_180.png": "1410",
	"./Weapon_181.png": "5078",
	"./Weapon_182.png": "ca41",
	"./Weapon_183.png": "9494",
	"./Weapon_184.png": "caeb",
	"./Weapon_185.png": "627a",
	"./Weapon_186.png": "d232",
	"./Weapon_187.png": "c49d",
	"./Weapon_188.png": "824c",
	"./Weapon_189.png": "86ced",
	"./Weapon_190.png": "7104c",
	"./Weapon_191.png": "db2d",
	"./Weapon_192.png": "dc59",
	"./Weapon_193.png": "a5246",
	"./Weapon_194.png": "2218",
	"./Weapon_195.png": "7c3c",
	"./Weapon_196.png": "0f82",
	"./Weapon_197.png": "26f2",
	"./Weapon_198.png": "a891",
	"./Weapon_199.png": "f15d",
	"./Weapon_20.png": "033b",
	"./Weapon_200.png": "f4a0",
	"./Weapon_201.png": "4e5a",
	"./Weapon_202.png": "4861",
	"./Weapon_203.png": "8881",
	"./Weapon_204.png": "fd7e6",
	"./Weapon_205.png": "5156",
	"./Weapon_206.png": "ffca",
	"./Weapon_207.png": "c7a8",
	"./Weapon_208.png": "80e4",
	"./Weapon_209.png": "26f4",
	"./Weapon_21.png": "31ca",
	"./Weapon_210.png": "a7cb",
	"./Weapon_211.png": "ad22",
	"./Weapon_212.png": "78cf",
	"./Weapon_213.png": "7094",
	"./Weapon_214.png": "741d",
	"./Weapon_215.png": "f030",
	"./Weapon_216.png": "898f",
	"./Weapon_217.png": "155d",
	"./Weapon_218.png": "d916",
	"./Weapon_219.png": "7f21",
	"./Weapon_22.png": "d6c5",
	"./Weapon_220.png": "b1ff",
	"./Weapon_223.png": "ee59",
	"./Weapon_224.png": "ef71",
	"./Weapon_225.png": "b194",
	"./Weapon_226.png": "a05b",
	"./Weapon_227.png": "caba",
	"./Weapon_228.png": "2369",
	"./Weapon_229.png": "d6af",
	"./Weapon_23.png": "06d9",
	"./Weapon_230.png": "6dc5",
	"./Weapon_231.png": "09c0",
	"./Weapon_232.png": "c94c",
	"./Weapon_233.png": "7f4a",
	"./Weapon_234.png": "6ed5",
	"./Weapon_235.png": "da83",
	"./Weapon_236.png": "1be5",
	"./Weapon_237.png": "425e",
	"./Weapon_238.png": "8f4c",
	"./Weapon_239.png": "734b",
	"./Weapon_24.png": "d934",
	"./Weapon_240.png": "a302",
	"./Weapon_241.png": "4370",
	"./Weapon_242.png": "a797",
	"./Weapon_243.png": "c061",
	"./Weapon_244.png": "241a",
	"./Weapon_245.png": "3c63",
	"./Weapon_246.png": "1220",
	"./Weapon_247.png": "1f09",
	"./Weapon_248.png": "2d36",
	"./Weapon_249.png": "955a",
	"./Weapon_25.png": "5d99",
	"./Weapon_250.png": "4c07",
	"./Weapon_251.png": "2041",
	"./Weapon_252.png": "3be5",
	"./Weapon_253.png": "4261",
	"./Weapon_254.png": "8d02",
	"./Weapon_255.png": "84e4",
	"./Weapon_256.png": "d1600",
	"./Weapon_257.png": "e277",
	"./Weapon_258.png": "7638",
	"./Weapon_259.png": "f024",
	"./Weapon_26.png": "e676",
	"./Weapon_260.png": "95fa",
	"./Weapon_261.png": "7cb50",
	"./Weapon_262.png": "4262",
	"./Weapon_263.png": "f77c",
	"./Weapon_264.png": "b20f",
	"./Weapon_265.png": "3ca4c",
	"./Weapon_266.png": "6669",
	"./Weapon_267.png": "ed0e",
	"./Weapon_268.png": "879f",
	"./Weapon_269.png": "3c29",
	"./Weapon_27.png": "604e",
	"./Weapon_270.png": "bfe7",
	"./Weapon_271.png": "840b",
	"./Weapon_272.png": "2a00",
	"./Weapon_273.png": "ac0d",
	"./Weapon_274.png": "2915",
	"./Weapon_275.png": "77b8",
	"./Weapon_276.png": "2af6",
	"./Weapon_277.png": "93a1",
	"./Weapon_278.png": "0a1b",
	"./Weapon_279.png": "6365",
	"./Weapon_28.png": "f307",
	"./Weapon_280.png": "be5a",
	"./Weapon_281.png": "81c6",
	"./Weapon_282.png": "dbb2",
	"./Weapon_283.png": "bc61",
	"./Weapon_284.png": "5bde",
	"./Weapon_285.png": "2009",
	"./Weapon_286.png": "3466",
	"./Weapon_287.png": "729c",
	"./Weapon_288.png": "582d",
	"./Weapon_289.png": "97e4",
	"./Weapon_290.png": "2955",
	"./Weapon_291.png": "4d3a",
	"./Weapon_292.png": "7376",
	"./Weapon_293.png": "0a82",
	"./Weapon_294.png": "6099",
	"./Weapon_295.png": "49f0",
	"./Weapon_296.png": "f8a2",
	"./Weapon_297.png": "df88",
	"./Weapon_298.png": "977f",
	"./Weapon_299.png": "acb9",
	"./Weapon_300.png": "26287",
	"./Weapon_301.png": "3a2d",
	"./Weapon_302.png": "08d1",
	"./Weapon_31.png": "7770",
	"./Weapon_32.png": "a955",
	"./Weapon_33.png": "10ee",
	"./Weapon_34.png": "80d8",
	"./Weapon_35.png": "b8ce",
	"./Weapon_36.png": "12f4",
	"./Weapon_37.png": "09db",
	"./Weapon_38.png": "2097",
	"./Weapon_39.png": "b0f5",
	"./Weapon_40.png": "15e3",
	"./Weapon_41.png": "0253",
	"./Weapon_42.png": "c32e",
	"./Weapon_43.png": "99e8",
	"./Weapon_44.png": "0b5f",
	"./Weapon_45.png": "6e4e",
	"./Weapon_46.png": "bb90",
	"./Weapon_47.png": "f586",
	"./Weapon_48.png": "776e",
	"./Weapon_49.png": "2fb2",
	"./Weapon_50.png": "4fe9",
	"./Weapon_51.png": "4389",
	"./Weapon_52.png": "d846",
	"./Weapon_53.png": "ab84",
	"./Weapon_54.png": "5eee",
	"./Weapon_55.png": "042e",
	"./Weapon_56.png": "28f2",
	"./Weapon_57.png": "8c17",
	"./Weapon_58.png": "e0da",
	"./Weapon_59.png": "bdd2",
	"./Weapon_60.png": "6124",
	"./Weapon_61.png": "481b",
	"./Weapon_62.png": "b077",
	"./Weapon_63.png": "7fbd",
	"./Weapon_64.png": "8c60",
	"./Weapon_65.png": "0255",
	"./Weapon_66.png": "6da3",
	"./Weapon_67.png": "f89a",
	"./Weapon_68.png": "ba65",
	"./Weapon_69.png": "6118",
	"./Weapon_70.png": "46d3",
	"./Weapon_71.png": "1ec5",
	"./Weapon_72.png": "4458",
	"./Weapon_73.png": "d001",
	"./Weapon_74.png": "495a",
	"./Weapon_75.png": "3073",
	"./Weapon_76.png": "eb72",
	"./Weapon_77.png": "400a",
	"./Weapon_78.png": "4c2a",
	"./Weapon_79.png": "7e4f",
	"./Weapon_80.png": "007fe",
	"./Weapon_81.png": "092c",
	"./Weapon_82.png": "7210",
	"./Weapon_83.png": "e708",
	"./Weapon_84.png": "7aee",
	"./Weapon_85.png": "8c59",
	"./Weapon_86.png": "9188",
	"./Weapon_87.png": "05f0",
	"./Weapon_88.png": "e18d",
	"./Weapon_89.png": "6300",
	"./Weapon_91.png": "3040",
	"./Weapon_92.png": "3039",
	"./Weapon_94.png": "8c2b",
	"./Weapon_95.png": "1f63e",
	"./Weapon_96.png": "1acf",
	"./Weapon_97.png": "5410",
	"./Weapon_99.png": "0780",
	"./Weapon_axe_01_mesh.png": "1b69",
	"./Weapon_bow_01_Arrow.png": "9755",
	"./Weapon_bow_01_mesh.png": "535a",
	"./Weapon_daga_01_mesh.png": "8a21",
	"./Weapon_magic_01_mesh.png": "4ad8",
	"./Weapon_shield_01_static.png": "6b40",
	"./Weapon_sword_01_mesh.png": "a8dc",
	"./Wp_2001.png": "051a",
	"./Wp_2002.png": "c5c1",
	"./Wp_2003.png": "4cbe",
	"./Wp_2004.png": "b582",
	"./Wp_2005.png": "e9b2",
	"./Wp_2006.png": "fd25",
	"./Wp_2007.png": "0eaf",
	"./Wp_2008.png": "bfb6",
	"./Wp_2009.png": "66fd",
	"./Wp_2010.png": "2f19",
	"./Wp_2011.png": "4d90",
	"./Wp_2012.png": "08c8",
	"./Wp_2013.png": "d451",
	"./Wp_2015.png": "f337",
	"./Wp_2016.png": "0353",
	"./Wp_2017.png": "0a34",
	"./Wp_2018.png": "a57f",
	"./Wp_2019.png": "d5f6",
	"./Wp_2020.png": "0fab",
	"./Wp_2021.png": "9b47",
	"./Wp_2022.png": "3841",
	"./Wp_2023.png": "dbff",
	"./Wp_2025.png": "e816",
	"./Wp_2026.png": "5dc2",
	"./Wp_2027.png": "570c",
	"./Wp_2028.png": "5a53",
	"./Wp_2029.png": "1fb3",
	"./Wp_2030.png": "ec13",
	"./Wp_2031.png": "1121",
	"./Wp_2032.png": "57c3",
	"./Wp_2033.png": "a1a9",
	"./Wp_2034.png": "ab85",
	"./Wp_2035.png": "af73",
	"./Wp_2037.png": "dfbd",
	"./Wp_2038.png": "087e",
	"./Wp_2040.png": "0c20",
	"./Wp_2041.png": "b974",
	"./Wp_2042.png": "6b5a",
	"./Wp_2043.png": "8bc6",
	"./Wp_2044.png": "b046",
	"./Wp_2045.png": "b61f",
	"./Wp_2046.png": "0617",
	"./Wp_2048.png": "f7a0",
	"./Wp_2050.png": "863d",
	"./Wp_2051.png": "af62",
	"./Wp_2052.png": "c9d5",
	"./Wp_2053.png": "eb9b",
	"./Wp_2054.png": "8034",
	"./Wp_2055.png": "c5d9",
	"./Wp_2056.png": "2aa8",
	"./Wp_2057.png": "cb24",
	"./Wp_2058.png": "b4b1",
	"./Wp_2059.png": "cbe7",
	"./Wp_2060.png": "10ad",
	"./Wp_2061.png": "dce8",
	"./Wp_2062.png": "64d9",
	"./Wp_2063.png": "7391",
	"./Wp_2064.png": "04c2",
	"./Wp_2065.png": "dbda",
	"./Wp_2066.png": "e9ce",
	"./Wp_2067.png": "9618",
	"./Wp_2068.png": "07ea",
	"./Wp_2069.png": "d029",
	"./Wp_2070.png": "e2d1",
	"./Wp_2071.png": "2ab7",
	"./Wp_2072.png": "fb93",
	"./Wp_2074.png": "d8b3",
	"./Wp_2075.png": "cf97",
	"./Wp_2076.png": "0178",
	"./Wp_2077.png": "8abb",
	"./Wp_2078.png": "dd17",
	"./Wp_2079.png": "60388",
	"./Wp_2080.png": "fa83",
	"./Wp_2081.png": "33f5",
	"./Wp_2082.png": "bf61",
	"./Wp_2084.png": "b958",
	"./Wp_2085.png": "3fab",
	"./Wp_2086.png": "0772",
	"./Wp_2087.png": "e86f",
	"./Wp_2088.png": "3942",
	"./Wp_2089.png": "1bb6",
	"./Wp_2090.png": "1560",
	"./Wp_2091.png": "86cb",
	"./Wp_2092.png": "0b55",
	"./Wp_2093.png": "1f75",
	"./Wp_2094.png": "4e25",
	"./_weapon_potion_04.png": "8e77",
	"./_weapon_potion_05.png": "8fe9",
	"./_weapon_potion_06.png": "e672",
	"./_weapon_potion_07.png": "f5d7",
	"./_weapon_potion_08.png": "c84e",
	"./_weapon_ring_11.png": "9100",
	"./_weapon_ring_12.png": "3276",
	"./_weapon_ring_13.png": "27ff",
	"./_weapon_ring_14.png": "18550",
	"./_weapon_spell_03.png": "b87b",
	"./_weapon_spell_04.png": "e87d",
	"./flur_00.png": "2cb9",
	"./greatsword_of_fn.png": "fa3d",
	"./inventory_00.png": "a433",
	"./potion_img_01.png": "27f4",
	"./potion_img_02.png": "fc7b",
	"./potion_img_03.png": "c546",
	"./potion_img_04.png": "fd8a",
	"./potion_img_05.png": "4f50",
	"./potion_img_06.png": "a3a4",
	"./potion_img_07.png": "e532",
	"./potion_img_08.png": "384b",
	"./stylized_fantasy_sword.png": "3afd",
	"./wep_spear01.png": "d711",
	"./wep_spear02.png": "7301",
	"./wep_spear03.png": "f6ecf",
	"./wep_spear04.png": "dc5d",
	"./wep_spear05.png": "e725"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cbdc";